import style from 'styled-components';

export const StyledMarker = style.i`
    color: ${props => props.theme.colors.buttonPrimaryBg}
`;
